module.exports = __webpack_public_path__ + "static/org_sfi-25202dd9b4167a64a1ba7a12bd02b094.png";